import { render, staticRenderFns } from "./BackupPage.vue?vue&type=template&id=8ac871c8"
import script from "./BackupPage.vue?vue&type=script&lang=js"
export * from "./BackupPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports